import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';
import * as dayjs from 'dayjs';
import {AppHotelService} from 'src/app/provider/app-hotel.service';
import {RequestsService} from 'src/app/provider/requests.service';
import {RequestHeaderModel} from 'src/app/views/models/request-header.model';
import {RequestLineModel} from 'src/app/views/models/request-line.model';

@Component({
  selector: 'kt-new-reservation',
  templateUrl: './new-reservation.component.html',
  styleUrls: ['./new-reservation.component.scss']
})
export class NewReservationComponent implements OnInit {

  mdata = null;
  rdata = null;
  selected = null;
  date = null;
  section = null;
  category = null;

  services = [];
  result = [];
  maxDay = [];
  maxTime = [];

  filter: string = null;
  room_no: string = null;
  guestName: string = null;
  notes: string = null;
  resTime: string = null;

  currentBook = 0;
  pax = 1;

  isSelected = false;

  constructor(
    private dialog: MatDialog,
    private appHotel: AppHotelService,
    private requestService: RequestsService
  ) {
  }

  ngOnInit() {
    this.appHotel.getMobileData(JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe(data => {
      this.mdata = data;

      this.mdata.menu_items.forEach(item => {
        if (item.booking_system == 'onDemand') {
          this.services.push(item);
          this.result.push(item);
        }
      });

    });

    this.appHotel.getRichData(JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe(data => {
      this.rdata = data;
    });
  }

  async close() {
    await this.dialog.closeAll();
  }

  filtered() {

    this.result = [];
    try {
      for (const item of this.services) {
        for (const filterWord of this.filter.split(' ')) {
          for (const name of Object.keys(JSON.parse(item.name))) {
            if (JSON.parse(item.name)[name]) {
              if (filterWord.toLowerCase() === JSON.parse(item.name)[name].substring(0, filterWord.length).toLowerCase()) {
                this.result.push(item);
              }
            }
          }
        }
      }
      this.result = [...new Set(this.result)];
    } catch (error) {
    }


  }

  select(item) {

    for (const sect of Object.keys(this.rdata)) {
      try {
        let section = null;
        if (this.rdata[sect].id === item.menu_section_id) {
          section = this.rdata[sect];
          this.section = section;
          this.findItem(section, item);
          break;
        }
      } catch {
        console.log('error');
      }
    }
  }

  findItem(section, sItem) {

    for (const cat of section.menu_categories) {
      for (const item of cat.menu_items) {
        if (item.id === sItem.id) {
          this.selected = item;
          this.category = cat;
          this.setMaxDay(0);
          this.isSelected = true;
          break;
        }
      }
    }
  }

  setMaxDay(index) {

    this.maxDay = [];
    this.currentBook = index;

    for (let i = 0; i < this.selected.menu_item_books[0].bookable_in_advance_days; i++) {
      if (this.selected.menu_item_books[0][dayjs(new Date()).add(i, 'day').format('dddd').toLowerCase()]) {
        this.maxDay.push(dayjs(new Date()).add(i, 'day').format('DD/MM/YYYY'));
      }
    }
  }

  setTime() {
    this.maxTime = [];
    const bookDetail = this.selected.menu_item_books[0].menu_item_book_details[this.currentBook];
    console.log(bookDetail);
    let addDate = null;

    addDate = dayjs(new Date()).set('hour', Number(bookDetail.start_time.split('T')[1].split(':')[0]))
      .set('minute', Number(bookDetail.start_time.split('T')[1].split(':')[1]));


    let endHour = Number(bookDetail.end_time.split('T')[1].split(':')[0]);
    let endMinute = Number(bookDetail.end_time.split('T')[1].split(':')[1]);

    if (endHour < bookDetail.start_time.split('T')[1].split(':')[0]) {
      endHour += 24;
    }

    if (endMinute === 0) {
      endMinute = 60;
    }

    if (bookDetail.book_detail_res_group && bookDetail.book_detail_res_group.length > 0) {
      for (const time of bookDetail.book_detail_res_group) {
        const TIME = `${time.default_time.split('T')[1].split(':')[0]}:${time.default_time.split('T')[1].split(':')[1]}`;
        const HOUR = Number(TIME.split(':')[0]);
        const MINUTE = Number(TIME.split(':')[1]);

        if (this.date === dayjs(new Date()).format('DD/MM/YYYY')) {
          if (HOUR >= Number(dayjs(new Date()).format('HH'))) {
            if ((HOUR !== Number(dayjs(new Date()).format('HH'))) || (HOUR === Number(dayjs(new Date()).format('HH')) && MINUTE >= Number(dayjs(new Date()).format('mm')))) {
              this.maxTime.push(TIME);
            }
          }
        } else {
          this.maxTime.push(TIME);
        }

      }
    } else {
      for (let k = 0; Number(addDate.add(k, 'hour').format('HH')) <= endHour; k++) {
        for (let j = 0; j < 60; j += bookDetail.interval) {
          if (this.date === dayjs(new Date()).format('DD/MM/YYYY')) {
            if (Number(addDate.add(k, 'hour').format('HH')) >= Number(dayjs(new Date()).format('HH'))) {
              if ((Number(addDate.add(k, 'hour').format('HH')) !== Number(dayjs(new Date()).format('HH')))
                || (Number(addDate.add(k, 'hour').format('HH')) === Number(dayjs(new Date()).format('HH'))
                  && Number(addDate.add(k, 'hour').format('mm')) >= Number(dayjs(new Date()).format('mm')))) {
                this.maxTime.push(addDate.add(k, 'hour').add(j, 'minute').format('HH:mm'));
              }
            }
          } else {
            this.maxTime.push(addDate.add(k, 'hour').add(j, 'minute').format('HH:mm'));
          }
        }
      }
    }
  }

  async book() {
    const requestTime: Date = await new Date(
      dayjs(new Date()).set('month', Number(this.date.split('/')[1]) - 1).set('date', Number(this.date.split('/')[0])).set('hour', Number(this.resTime.split(':')[0])).set('minute', Number(this.resTime.split(':')[1])).format());

    const rh = new RequestHeaderModel();

    rh.hotel_id = Number(JSON.parse(localStorage.getItem('token_form')).app_hotel_id);
    rh.room_no = this.room_no;
    rh.menu_section_id = this.selected.menu_section_id;

    rh.menu_section_name = this.section.title.includes('{') ? JSON.parse(this.section.title).en : this.section.title;

    rh.note = this.notes;
    rh.type = 'Facility Reservation';
    rh.reservation_type = this.category.title.includes('{') ? JSON.parse(this.category.title).en : this.category.title;

    rh.approval_status = 'pending';
    rh.menu_category_id = this.selected.menu_category_id;
    rh.menu_item_id = this.selected.id;
    rh.point = this.selected.loyalty_max_point;


    rh.menu_category_name = this.category.title.includes('{') ? JSON.parse(this.category.title).en : this.category.title;

    rh.menu_item_name = JSON.parse(this.selected.name).tr;
    rh.status = '';
    rh.order_date = requestTime;

    const Line: RequestLineModel = new RequestLineModel();
    Line.request_type = 'Menu Item';
    Line.request_type_id = this.selected.id;
    Line.request_type_name = this.selected.name;
    Line.type = 'Profile';
    Line.name = this.guestName;
    if (this.selected.menu_section_id == 104) {
      Line.unit_of_measure = 'Çocuk';
    } else {
      Line.unit_of_measure = 'Kişi';
    }
    Line.menu_section_id = rh.menu_section_id;
    Line.menu_section_name = rh.menu_section_name;
    Line.menu_category_id = rh.menu_category_id;
    Line.menu_category_name = rh.menu_category_name;
    Line.menu_item_id = rh.menu_item_id;
    Line.menu_item_name = rh.menu_item_name;
    Line.quantity = Number(this.pax);

    Line.unit_price = this.selected.menu_item_books[0].menu_item_book_details[this.currentBook].activate_offer
      ? this.selected.menu_item_books[0].menu_item_book_details[this.currentBook].offer_price
      : this.selected.menu_item_books[0].menu_item_book_details[this.currentBook].price;

    Line.amount = Line.quantity * Line.unit_price;

    try {
      Line.description =  JSON.parse(this.selected.description).tr || '';
    } catch {
      Line.description = '';
    }


    rh.requestlines.push(Line);

    try {
      this.requestService.postRequest([rh]);
      this.close();
    } catch (error) {
      alert(error.message);
    }
  }
}
